module.exports = __webpack_public_path__ + "img/cold-dish.4a9fd41b.svg";